import * as types from '../constants/ActionTypes';
import initialState from './initialState';

export default function(state = initialState.busquedaExpedientes, action) {
  switch (action.type) {
    case types.SET_FILTROS:
      return {
        ...state,
        ...action.payload.filtros,
      };

    case types.REINICIAR:
      return initialState.expediente;

    default:
      return state;
  }
}
